import * as React from "react";
import * as moment from "moment";

var FileItem = function FileItem(props) {
  var file = props.file,
      admin = props.admin,
      onEdit = props.onEdit,
      onDelete = props.onDelete;

  var formatDate = function formatDate(dateString) {
    if (!dateString) return "";
    return moment(dateString).format("DD-MM-YYYY HH:mm");
  };

  var getFileUrl = function getFileUrl() {
    var _file$file;

    if ((_file$file = file.file) !== null && _file$file !== void 0 && _file$file.url) {
      return file.file.url;
    }

    return "#";
  };

  var getFileName = function getFileName() {
    var _file$file2;

    if ((_file$file2 = file.file) !== null && _file$file2 !== void 0 && _file$file2.url) {
      var urlParts = file.file.url.split("/");
      return urlParts[urlParts.length - 1];
    }

    return "Archivo";
  };

  var canEdit = admin.is_super_admin || admin.permissions_code.includes("poliza_file_edit");
  var canDelete = admin.is_super_admin || admin.permissions_code.includes("poliza_file_delete");
  return /*#__PURE__*/React.createElement("div", {
    className: "file-item",
    style: {
      marginBottom: "15px",
      padding: "15px",
      border: "1px solid #e0e0e0",
      borderRadius: "6px",
      backgroundColor: "#fff",
      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: getFileUrl(),
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      fontSize: "14px",
      fontWeight: "500",
      color: "#2596be",
      textDecoration: "none"
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-file-pdf",
    style: {
      marginRight: "8px",
      color: "#dc3545"
    }
  }), getFileName())), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "12px",
      color: "#666",
      marginBottom: "8px",
      paddingTop: "10px",
      borderTop: "1px solid #f0f0f0"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Subido por:"), " ", file.created_by_email || "Desconocido", " el ", formatDate(file.created_at)), file.updated_by_id && file.updated_by_id !== file.created_by_id && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "4px"
    }
  }, /*#__PURE__*/React.createElement("strong", null, "Editado por:"), " ", file.updated_by_email || file.created_by_email, " el ", formatDate(file.updated_at))), (canEdit || canDelete) && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "10px",
      display: "flex",
      gap: "8px"
    }
  }, canEdit && /*#__PURE__*/React.createElement("button", {
    className: "btn btn-xs btn-secondary",
    onClick: onEdit,
    style: {
      padding: "4px 12px",
      fontSize: "12px"
    }
  }, "Editar"), canDelete && /*#__PURE__*/React.createElement("button", {
    className: "btn btn-xs btn-danger",
    onClick: onDelete,
    style: {
      padding: "4px 12px",
      fontSize: "12px"
    }
  }, "Eliminar")));
};

export default FileItem;